/* eslint-disable no-unused-vars */

import React, { useState, useRef } from 'react';
import Modal from '../../component/Modal';
import Logo from '../../../assets/img/logo.png';
import { useNavigate } from 'react-router-dom';
import { nvl } from '../../../utils/Common.utils';
import request from '../../../utils/Request.utils';
import SessionStorage from '../../../utils/SessionStorage.utils';
import "../../../assets/scss/page/member.scss";

function Login({ setLoginStatus }) {
  const [modalAlert, setModalAlert] = useState(false);
  const adminIdRef = useRef();
  const adminPasswdRef = useRef();
  const [loginmsg, setLoginMsg] = useState('');
  const [managerPasswdFailCnt, setManagerPasswdFailCnt] = useState(0);
  // const [showPicture, setShowPicture] = useState(false);
  const navigate = useNavigate();

  // 로그인
  const adminLogin = () => {
    // 메시지삭제
    setLoginMsg('');

    if (nvl(adminIdRef.current.value) === '') {
      setLoginMsg('아이디가 입력되지 않았습니다.');
      return;
    } else if (nvl(adminPasswdRef.current.value) === '') {
      setLoginMsg('패스워드가 입력되지 않았습니다.');
      return;
    }

    let params = {
      admin_id: adminIdRef.current.value,
      admin_pwd: adminPasswdRef.current.value,
    };

    const successHandler = (response) => {
      if (response.messageCode === 200) {
        // 토큰저장
        SessionStorage.clearItem('adminSession');
        SessionStorage.setItem('adminSession', 'accessToken', response.data.accessToken);
        SessionStorage.setItem('adminSession', 'refreshToken', response.data.refreshToken);

        // Header변경
        setLoginStatus(true);

        // 메인 첫페이지 키워드광고로 이동
        navigate('/Member/MemberManage');
      } else {
        setLoginMsg('잘못된 정보 이거나 가입 정보가 없습니다.');
      }
    };

    const failHandler = (response) => {
      if (managerPasswdFailCnt > 3) {
        //   setShowPicture(true);
      }
      setManagerPasswdFailCnt((pre) => pre + 1);
      setLoginMsg('아이디 또는 패스워드가 다릅니다.');
    };

    request.post('/admin/login', params, successHandler, failHandler);
  };


  return (
    <main className='p_adm_login'>
      <div className='box'>
        <h1 className='site_name'>
          <img src={Logo} className="img" alt="logo" />
        </h1>
        <h1 className='site_name'>Back Office</h1>
        <h2 className='title'>관리자 로그인</h2>
        <div className="adm_com_input_wrap">
          <section className='sec_input'>
            <input type='text' ref={adminIdRef} className='input' />
          </section>
          <section className='sec_input'>
            <input type='password' ref={adminPasswdRef} className='input' />
          </section>
        </div>
        {/* <p className="error_txt">ID 또는 PW가 정확하지 않습니다. <br />
          <span className="cnt">4</span>회 남았습니다.
        </p> */}
        <p className="error_txt">{loginmsg}<br />
          {/* <span className="cnt">4</span>회 남았습니다. */}
        </p>
        <div className="adm_com_btn_wrap center">
          <button className="adm_com_btn m blue" onClick={() => adminLogin()}>로그인</button>
        </div>
      </div>
      {/* Modal */}
      <Modal open={modalAlert} close={() => setModalAlert(false)}>
        <div className="content_container scroll">
          <p>5회 이상 ID 또는 PW 입력오류 입니다.<br />관리자에게 문의하세요.</p>
        </div>
        <div className="btn_container">
          <button className="adm_com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default Login;
